import React from "react";

import AdvertisingOfferPlanList from "./AdvertisingOfferPlanList";
import PauseAdParameters from "./PauseAdParameters";
import VASTParameters from "./VASTParameters";

import type { JSX } from "react";

import type { IAdvertisingSingle, VASTFormChange } from "../../types";

interface Props {
  onChange: VASTFormChange;
  advertisingCampaign: IAdvertisingSingle;
}

function VASTForm({ onChange, advertisingCampaign }: Props): JSX.Element {
  return (
    <div className="editor-tile-container divide-y">
      <VASTParameters campaign={advertisingCampaign} onChange={onChange} />
      <PauseAdParameters campaign={advertisingCampaign} onChange={onChange} />
      <AdvertisingOfferPlanList advertisingCampaign={advertisingCampaign} />
    </div>
  );
}

export default VASTForm;
